/**
 * Aufstieg auf „Schwer“: Wer auf „Normal“ mehrere Legislaturen regiert hat, kann nach einer
 * gewonnenen Wahl für die nächste Legislatur auf „Schwer“ wechseln.
 * Wer dabei schon sehr stark ist, startet mit einem Abschlag in den Umfragen.
 * Zieht keinen Zufall. Partien ohne Wechsel bleiben unverändert.
 */
import { S, log } from './state';
import { CF } from '../content/settings';
import { since } from './version';

/** Ab dieser Zahl abgeschlossener Legislaturen wird der Wechsel angeboten. */
export const HARD_AFTER = 3;

/** Wird der Wechsel jetzt angeboten (Endbildschirm nach gewonnener Wahl)? */
export function hardOffer(): boolean {
  return !!S && !S.mp && !since(12) && S.phase === 'end' && S.end === 'election' && !!(S as any).won
    && CF().diff === 'normal' && !(S as any).chal && S.leg + 1 - ((S as any).oppLegs || 0) >= HARD_AFTER;
}

/** Umfrage-Abschlag beim Wechsel: ab 50 % je zwei Punkte über 50 einen Punkt, höchstens 5. */
export function hardPenalty(share: number): number {
  return share <= 50 ? 0 : Math.min(5, Math.round((share - 50) / 2 * 10) / 10);
}

/** Wechsel durchführen. Aufruf in nextLeg, nachdem das neue Wahlergebnis übernommen ist. */
export function goHard() {
  const pen = hardPenalty(S.final);
  const c = CF() as any;
  S.cfg = { ...c, diff: 'schwer', adm: Number(c.adm ?? 1) >= 1 ? 2 : 0 };
  if (pen > 0) S.elec = Math.max(4, S.elec - pen);
  (S as any).hardFrom = S.leg;
  log(`Ab jetzt auf „Schwer“.${pen > 0 ? ` Euer Vorsprung schmilzt: ${String(pen).replace('.', ',')} Punkte weniger in den Umfragen.` : ''}`, pen > 0 ? 'bad' : '');
}
